export default "__VITE_ASSET__C6bbk3rD__"